import { ECourseStatus } from '@constants';
import { useMemo } from 'react';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

import { EIconType, Icon } from '../Icon';

import { StyledTag, TextWrapper } from './CourseStatusTag.styles';

type Props = {
  status: ECourseStatus;
  icon?: EIconType;
};

export const CourseStatusTag: React.FC<Props> = ({ status, icon }) => {
  const { t } = useTranslation('CoursesTranslations');
  const { colors } = useTheme();

  const determineStyle = useCallback(() => {
    if (status === ECourseStatus.ARCHIVED)
      return { color: colors.red6, backgroundColor: `${colors.red6}20` };
    if (status === ECourseStatus.DRAFT)
      return { color: colors.orange6, backgroundColor: `${colors.orange6}20` };
    return { color: colors.green6, backgroundColor: colors.green1 };
  }, [status, colors]);

  const { color, backgroundColor } = useMemo(determineStyle, [determineStyle]);

  return (
    <StyledTag $color={backgroundColor} $borderColor={color}>
      {icon && <Icon i={icon} />}
      <TextWrapper $color={color}>{t(status)}</TextWrapper>
    </StyledTag>
  );
};
